import REDSURVEY_PAGE from "@/redsurvey/routes/redsurvey-page";
export default [
  {
    path: REDSURVEY_PAGE.SURVEY_RESPONSE, //설문메인페이지
    name: "surveyResponse",
    component: () => import("@/redsurvey/views/survey/SurveyResponse.vue"),
    props: true,
    children: []
  },
  {
    path: REDSURVEY_PAGE.SURVEY_RESPONSE_PREVIEW, //설문 프리뷰 페이지
    name: "surveyResponsePreview",
    component: () => import("@/redsurvey/views/survey/SurveyResponsePreview.vue"),
    props: true,
  },
];
